import { useState, useContext } from 'react';
import Modal from 'components/modal/Modal';
import { generatePath, useHistory, useLocation } from 'react-router-dom';
import { StoreContext } from 'index';
import { GrowthTrackerModalView } from 'containers/pages/growthtracker/modals/growth-tracker-modal-view';
import SelectGroupModal from 'containers/pages/growthtracker/modals/SelectGroupModal';
import GrowthChoiceView from 'containers/pages/growthtracker/modals/GrowthChoiceView';
import SelectSessionView from 'containers/pages/growthtracker/modals/SelectSessionView';
import SelectSporterView from 'containers/pages/growthtracker/modals/SelectSporterView';
import {
  ROUTE_GROWTH_ENTITY,
  ROUTE_GROWTH_ENTITY_GROUP,
  ROUTE_GROWTH_ENTITY_SESSION,
  ROUTE_GROWTH_ENTITY_PERSON
} from 'routes/RouteList';

const GrowthMainModal = ({
  entityId,
  master,
  onSubmitHandler,
  onCloseHandler,
  ...props
}) => {
  const {
    authStore: {
      user: { rootEntityId }
    }
  } = useContext(StoreContext);

  const [view, setView] = useState(props.view || GrowthTrackerModalView.GROUP);

  const { push, goBack } = useHistory();
  const { pathname } = useLocation();

  const onSubmitClientHandler = (id, extraId, name) => {
    if (onSubmitHandler && typeof onSubmitHandler === 'function') {
      onSubmitHandler(id, extraId, name);
    }
  };

  const onSubmitMasterHandler = (id, extraId) => {
    let route;
    switch (view) {
      case GrowthTrackerModalView.GROUP:
        route = ROUTE_GROWTH_ENTITY_GROUP.replace(':groupId', id);
        break;
      case GrowthTrackerModalView.SPORTER:
        route = ROUTE_GROWTH_ENTITY_PERSON.replace(':personId', id).replace(
          ':groupId',
          extraId
        );
        break;
      case GrowthTrackerModalView.SESSION:
        route = ROUTE_GROWTH_ENTITY_SESSION.replace(':sessionId', id);
        break;
      default:
        route = ROUTE_GROWTH_ENTITY;
    }

    route = generatePath(route, {
      popup: 'default',
      entityId: rootEntityId,
      benchmarkId: 'default'
    });

    if (onCloseHandler && typeof onCloseHandler === 'function') {
      onCloseHandler();
    }
    if (route !== pathname) {
      push(route);
    }
  };

  const onCancelHandler = () => {
    if (onCloseHandler && typeof onCloseHandler === 'function') {
      onCloseHandler();
    } else {
      goBack();
    }
  };

  const getView = view => {
    switch (view) {
      case GrowthTrackerModalView.CHOICE:
        return GrowthChoiceView;
      case GrowthTrackerModalView.GROUP:
        return SelectGroupModal;
      case GrowthTrackerModalView.SESSION:
        return SelectSessionView;
      case GrowthTrackerModalView.SPORTER:
        return SelectSporterView;
      default:
        return SelectGroupModal;
    }
  };

  const Component = getView(view);

  return (
    <Modal
      card
      isOpen
      onClose={onCloseHandler}
      extraClassNames="c-modal__content-bottom-auto"
    >
      <Component
        entityId={entityId}
        onChangeView={view => setView(view)}
        onCancelHandler={onCancelHandler}
        onSubmitHandler={master ? onSubmitMasterHandler : onSubmitClientHandler}
      />
    </Modal>
  );
};

export default GrowthMainModal;
